import { BaseApi } from "api/BaseApi.ts";

import GetPartnerRequest = App.Http.Requests.Partner.GetPartnerRequest;
import GetPartnersRequest = App.Http.Requests.Partner.GetPartnersRequest;
import GetPartnersResponse = App.Http.Responses.Partner.GetPartnersResponse;
import GetPartnerResponse = App.Http.Responses.Partner.GetPartnerResponse;
import GetPartnerInviteInfoResponse = App.Http.Responses.Partner.GetPartnerInviteInfoResponse;

class PartnerApi extends BaseApi {
    /**
     * Get paginated list of partners
     *
     * - Request: GetPartnersRequest
     * - Response: GetPartnersResponse
     */
    async index(request: GetPartnersRequest): Promise<GetPartnersResponse> {
        return this.get<GetPartnersResponse, GetPartnersRequest>("/partners", {
            params: request,
        });
    }

    /**
     * Get specific partner
     *
     * - Request: { id: string }
     * - Response: GetPartnerResponse
     */
    async show(partnerId: string, request?: GetPartnerRequest): Promise<GetPartnerResponse> {
        return this.get<GetPartnerResponse, GetPartnerRequest>(`/partners/${partnerId}`, {
            params: request,
        });
    }

    /**
     * Get invite info for a partner: the caller's own tenants where they're admin, decorated
     * with the partner's current roles there and whether an AffiliatePartner invite is possible.
     *
     * - Request: { partnerId: string }
     * - Response: GetPartnerInviteInfoResponse
     */
    async inviteInfo(partnerId: string): Promise<GetPartnerInviteInfoResponse> {
        return this.get<GetPartnerInviteInfoResponse, never>(`/partners/${partnerId}/invite-info`);
    }
}

export const partnerApi = new PartnerApi();
